import { render, staticRenderFns } from "./upload-page.vue?vue&type=template&id=370c8106"
import script from "./upload-page.vue?vue&type=script&lang=js"
export * from "./upload-page.vue?vue&type=script&lang=js"
import style0 from "./upload-page.vue?vue&type=style&index=0&id=370c8106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports